import UserPermissionPage from '@/components/feature/UserPermissionPage/UserPermissionPage'

const UserPermission = () => <UserPermissionPage />

export default UserPermission
